// extracted by mini-css-extract-plugin
export default {"container":"CampaignTop_container__teaI3","responsiveContainer":"CampaignTop_responsiveContainer__msxel"};